import React from "react";
import './install.css'

export default function AboutUs(){
    return(
        <div className="about-section" id="about">
            <div className="about-container">
                <div className="about-content">
                    <h2 className="about-title">Building Tomorrow's Technology Today</h2>
                    <p className="about-description">
                        Founded with a vision to democratize technology education and innovation, Appmend has grown into a trusted partner for individuals and organizations seeking digital transformation.
                    </p>
                    <div className="about-stats">
                        <div className="stat-item">
                            <h3>500+</h3>
                            <p>Students Trained</p>
                        </div>
                        <div className="stat-item">
                            <h3>50+</h3>
                            <p>Projects Delivered</p>
                        </div>
                        <div className="stat-item">
                            <h3>3</h3>
                            <p>Cloud Platforms</p>
                        </div>
                    </div>
                </div>
                <div className="about-values">
                    <div className="value-card">
                        <div className="value-icon">🎯</div>
                        <h4>Our Mission</h4>
                        <p>Empowering individuals and organizations with cutting-edge technology solutions and knowledge.</p>
                    </div>
                    <div className="value-card">
                        <div className="value-icon">👁️</div>
                        <h4>Our Vision</h4>
                        <p>To be the leading catalyst for digital transformation in education and enterprise.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}